var FAILED = 'FAILED';
var STARTED = 'STARTED';
var SUCCEEDED = 'SUCCEEDED';
var UNINITIALIZED = 'UNINITIALIZED';
export var RequestStates = {
  FAILED: FAILED,
  STARTED: STARTED,
  SUCCEEDED: SUCCEEDED,
  UNINITIALIZED: UNINITIALIZED
};